import DeprecatedUserDashboard from "./deprecated-user-dashboard";
import React from "react";
import UserDashboard from "./user-dashboard";
import useFeatureFlags from "utilities/hooks/use-feature-flags";

const UserDashboardPage: React.FC = () => {
    const { useNewUserDashboard } = useFeatureFlags();

    return useNewUserDashboard ? (
        <UserDashboard />
    ) : (
        <DeprecatedUserDashboard />
    );
};

export default UserDashboardPage;
